import API from '@/services/api'

// Actions
export const FETCH_USERS = 'fetchUsers'
export const FETCH_ALL_USERS = 'fetchAllUsers'
export const FETCH_USER = 'fetchUser'
export const CREATE_USER = 'createUser'
export const UPDATE_USER = 'updateUser'
export const DELETE_USER = 'deleteUser'

// Mutations
export const STORE_SET_USERS = 'storeSetUsers'
export const STORE_ADD_USER = 'storeAddUser'
export const STORE_UPDATE_USER = 'storeUpdateUser'
export const STORE_DELETE_USER = 'storeDeleteUser'

// Only the latest request may update the list, so slow responses for older search terms are ignored
let latestUsersRequest = 0

const state = {
	users: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1,
		},
	},
}

const getters = {
	users (state) {
		return state.users
	},
}

const actions = {
	[FETCH_USERS] (context, options) {
		const request = ++latestUsersRequest
		let query = 'users?page=' + options.page

		if (options.search) {
			query += '&search=' + encodeURIComponent(options.search)
		}

		return new Promise((resolve, reject) => {
			API.query(query).then((response) => {
				if (request === latestUsersRequest) {
					context.commit(STORE_SET_USERS, response.data)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_ALL_USERS] () {
		return new Promise((resolve, reject) => {
			API.query('users').then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			});
		})
	},
	[FETCH_USER] (context, user) {
		return new Promise((resolve, reject) => {
			API.query('users/' + user).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_USER] (context, user) {
		return new Promise((resolve, reject) => {
			API.post('users', user).then((response) => {
				context.commit(STORE_ADD_USER, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_USER] (context, object) {
		return new Promise((resolve, reject) => {
			API.update('users', object.id, object.changes).then((response) => {
				context.commit(STORE_UPDATE_USER, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_USER] (context, user) {
		return new Promise((resolve, reject) => {
			API.delete('users/' + user.id).then((response) => {
				context.commit(STORE_DELETE_USER, user)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_USERS] (state, users) {
		state.users = users
	},
	[STORE_ADD_USER] (state, user) {
		state.users.data.push(user)
	},
	[STORE_UPDATE_USER] (state, user) {
		let users = []

		state.users.data.map((mapUser) => {
			if (mapUser.id === user.id) {
				mapUser = user
			}

			users.push(mapUser)
		})

		state.users.data = users
	},
	[STORE_DELETE_USER] (state, user) {
		state.users.data.splice(state.users.data.indexOf(user), 1)
	},
}

export default { state, getters, actions, mutations }